exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/_wks-ext.js
 ** module id = 100
 ** module chunks = 0
 **/